import {
  INSTRUMENTS_DETAILS_GET,
  INSTRUMENTS_GET,
  INSTRUMENTS_LIST_GET,
  INSTRUMENTS_PERFORMANCE_GET,
  INSTRUMENTS_KPIS_GET,
  ETFS_LIST_GET,
  ETFS_BROAD_ASSET_CLASSES_GET,
  ETFS_BENCHMARK_INDICES_GET,
  FUNDS_LIST_GET,
  FUNDS_BROAD_ASSET_CLASSES_GET,
  FUNDS_BENCHMARK_INDICES_GET,
} from '../actions/types';

const initialState = {
  items: {},
  latest: [],
  performances: {},
  intervalKpis: {},
  etfs: {
    items: [],
    filters: {},
    broadAssetClasses: [],
    benchmarkIndices: [],
  },

  funds: {
    items: [],
    filters: {},
    broadAssetClasses: [],
    benchmarkIndices: [],
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case INSTRUMENTS_GET._SUCCESS: {
      const { instrument } = action.payload;
      state.items[instrument.id] = instrument;
      return state;
    }
    case INSTRUMENTS_LIST_GET._SUCCESS: {
      const { instruments, orderBy } = action.payload;
      if (orderBy === 'descdate') {
        state.latest = instruments;
      }
      instruments.forEach((instrument) => {
        state.items[instrument.id] = instrument;
      });
      return state;
    }
    case INSTRUMENTS_DETAILS_GET._SUCCESS: {
      const { instruments } = action.payload;
      instruments.forEach((instrument) => {
        state.items[instrument.id] = instrument;
      });
      return state;
    }
    case INSTRUMENTS_PERFORMANCE_GET._SUCCESS: {
      const {
        instrumentId,
        performanceChartYearsTag,
        performanceChartBenchmarkId,
        performanceChart,
        compareIds,
      } = action.payload;
      if (compareIds) {
        state.performances[instrumentId] = {
          comparisons: {
            [compareIds]: {
              performanceChartBenchmarkId,
              performanceChart,
              performanceChartYearsTag,
            },
          },
        };
      } else {
        state.performances[instrumentId] = {
          performanceChartYearsTag,
          performanceChartBenchmarkId,
          performanceChart,
        };
      }
      return state;
    }
    case INSTRUMENTS_KPIS_GET._SUCCESS: {
      const { instrumentId, kpis } = action.payload;

      state.intervalKpis[instrumentId] = {
        kpis,
      };
      return state;
    }
    case ETFS_LIST_GET._SUCCESS: {
      const { etfs, filters } = action.payload;
      state.etfs.items = etfs;
      state.etfs.filters = filters;
      return state;
    }
    case ETFS_BROAD_ASSET_CLASSES_GET._SUCCESS: {
      const { broadAssetClasses } = action.payload;
      state.etfs.broadAssetClasses = broadAssetClasses.filter(Boolean);
      return state;
    }
    case ETFS_BENCHMARK_INDICES_GET._SUCCESS: {
      const { benchmarkIndices } = action.payload;
      state.etfs.benchmarkIndices = benchmarkIndices.filter(Boolean);
      return state;
    }
    case FUNDS_LIST_GET._SUCCESS: {
      const { funds, filters } = action.payload;
      state.funds.items = funds;
      state.funds.filters = filters;
      return state;
    }
    case FUNDS_BROAD_ASSET_CLASSES_GET._SUCCESS: {
      const { broadAssetClasses } = action.payload;
      state.funds.broadAssetClasses = broadAssetClasses.filter(Boolean);
      return state;
    }
    case FUNDS_BENCHMARK_INDICES_GET._SUCCESS: {
      const { benchmarkIndices } = action.payload;
      state.funds.benchmarkIndices = benchmarkIndices.filter(Boolean);
      return state;
    }
    default:
      return state;
  }
};

export { reducer as instruments };
